/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { BLACK_COLOR, CURVE_CONTROL_POINT_STROKE, SELECTED_CURVE_POINT_COLOR, WHITE_COLOR } from "../../Constants";
import {
	PathOperation,
} from "../interfaces/model/geometry/ShapePath";
import { IDragResults } from "../meta/Drag/CsiDragController";
import * as util from "../util";
import { AdjustablePoint } from "./AdjustablePoint";

interface ICurveControlPointProps {
    operation: PathOperation;
    isCropShape?: boolean;
    isHandle?: boolean;
    isSelectedPoint: boolean;
    hide?: boolean;
    onPointDrag(data: any, dx: number, dy: number): void;
    onPointDragComplete(data: any, drag: IDragResults): void;
    onPointClick?(data: any): void;
    onPointerDown?(data: any): void;
    onPointDblClick?(data: any): void;
};

/**
 * Curve control point. It will render the control point for the curve and handle events such as click and drag.
 * All required shape manipulations must be done the parent widget.
 */
export class CurveControlPoint extends WidgetBase<ICurveControlPointProps> {
	/**
     * Passed as parameter to adjustable point. This method is invoked when point is dragged.
     * @param key key for the element.
     * @param data {any} data to identify clicked point.
     * @param dx {number} x change in point.
     * @param dy {number} y change in point.
     */
	protected onPointDrag(key: string | number | undefined, data: any, dx: number, dy: number) {
		this.properties.onPointDrag(data, dx, dy);
	}

	/**
     * Extension point to handle point dragging complete.
     * @param key {String | number} key to identify widget.
     * @param data  {any} data associated with the widget.
     */
	protected onPointDragComplete(key: string | number | undefined, data: any, dragResult: IDragResults) {
		this.properties.onPointDragComplete(data, dragResult);
	}

	protected render() {
		const markerPoint = util.getPathEndPoint(this.properties.operation);
		let fillColor = WHITE_COLOR;
		if (this.properties.isSelectedPoint) {
			if (this.properties.isCropShape) {
				fillColor = BLACK_COLOR;
			} else {
				fillColor = SELECTED_CURVE_POINT_COLOR;
			}
		}

		if (markerPoint) {
			//// Keeping this code comented for now, this will render the control points for the point on curve.
			//// In future we want a way to update these control points.

			// if (this.properties.operation.type === PathOperationTypes.CUBIT_BEZ_TO ||
			//     this.properties.operation.type === PathOperationTypes.QUAD_BEZ_TO) {
			//     let cubic = this.properties.operation as IDrawCubicBezierCurveTo;
			//     let adjustablePoints: DNode[] = [];
			//     // max index
			//     let index = 0;
			//     _.forEach(cubic.pts, (pt: IShapePositionCoordinate) => {
			//         let data = {
			//             operationIndex: this.properties.key,
			//             pointIndex: index,
			//         };

			//         let key = index;
			//         let adjustablePointProps = {
			//             x: pt.x as number, data, y: pt.y as number,
			//             key, onChange: this.onPointDrag, onClick: this.properties.onPointClick, stroke: "blue",
			//         };
			//         adjustablePoints.push(w(AdjustablePoint, adjustablePointProps));
			//         index++;
			//     });
			//     return adjustablePoints;
			// } else {
			const data = {
				operationIndex: this.properties.key,
				pointIndex: 0,
			};

			const y = markerPoint.y as number;
			const x = markerPoint.x as number;

			const key = `marker:${this.properties.key}:0`;
			const { hide } = this.properties;
			const adjustablePointProps = {
				hide,
				fill: fillColor,
				id: 0, x, y, key, data,
				isHandle: this.properties.isHandle,
				onClick: this.properties.onPointClick,
				onDblClick: this.properties.onPointDblClick,
				onPointerDown: this.properties.onPointerDown,
				onDrag: this.onPointDrag,
				onDragComplete: this.onPointDragComplete,
				stroke: this.properties.isCropShape ? BLACK_COLOR : CURVE_CONTROL_POINT_STROKE,
			};

			return (
				<AdjustablePoint {...adjustablePointProps} />
			);
			// }
		} else {
			return null;
		}
	}
}
